"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setPosition = (progressPosition, progressSize) => {
  switch (progressPosition) {
    case 'top':
    default:
      return (0, _styledComponents.css)`
        top: 0;
        left: 0;
        right: 0;
        height: ${progressSize}px;
        width: 100%;
      `;
    case 'bottom':
      return (0, _styledComponents.css)`
        bottom: 0;
        left: 0;
        right: 0;
        height: ${progressSize}px;
        width: 100%;
      `;
    case 'left':
      return (0, _styledComponents.css)`
        left: 0;
        top: 0;
        width: ${progressSize}px;
        height: 100%;
      `;
    case 'right':
      return (0, _styledComponents.css)`
        right: 0;
        top: 0;
        width: ${progressSize}px;
        height: 100%;
      `;
  }
};
const getProgressScale = progressPosition => {
  switch (progressPosition) {
    case 'left':
    case 'right':
      return (0, _styledComponents.css)`
        scale: 1 0;
      `;
    case 'top':
    case 'bottom':
    default:
      return (0, _styledComponents.css)`
        scale: 0 1;
      `;
  }
};
const colorChangeAnimation = colors => {
  if (colors.length > 1) {
    const steps = 100 / (colors.length - 1);
    const keyframe = colors.reduce((acc, color, index) => {
      return `${acc}${Math.round(steps * index)}% { background-color: ${color} } `;
    }, '');
    return (0, _styledComponents.keyframes)`
      ${keyframe}
    `;
  }
  return (0, _styledComponents.keyframes)`
    0% { background-color: ${colors[0] || '#000'} }
    100% { background-color: ${colors[0] || '#000'} }
  `;
};
const setProgressAlignment = (progressAlignment, progressPosition) => {
  if (progressPosition === 'left' || progressPosition === 'right') {
    const progressAlignmentMap = {
      start: 'top',
      center: 'center',
      end: 'bottom'
    };
    return (0, _styledComponents.css)`
      transform-origin: ${progressPosition}
        ${progressAlignmentMap[progressAlignment]};
    `;
  }
  const progressAlignmentMap = {
    start: 'left',
    center: 'center',
    end: 'right'
  };
  return (0, _styledComponents.css)`
    transform-origin: ${progressAlignmentMap[progressAlignment]}
      ${progressPosition};
  `;
};
const Progress = _styledComponents.default.div`
  position: fixed;

  ${props => setPosition(props.progressPosition, props.progressSize)};
  ${props => setProgressAlignment(props.progressAlignment, props.progressPosition)};

  @keyframes scaleProgress {
    0% {
      ${props => getProgressScale(props.progressPosition)};
    }
    100% {
      scale: 1 1;
    }
  }
  animation: scaleProgress auto linear,
    ${props => colorChangeAnimation(props.colors)} auto linear forwards;
  animation-timeline: scroll();
`;
exports.Progress = Progress;
//# sourceMappingURL=styles.js.map